module.exports = "/_next/static/images/xk-4f3781ca449bb8e7fae1e0de1b3ef426.svg";